<template>
  <v-window-item :value="2" class="pa-3 fill-height">
    <template v-if="!loading && projectOptions">
      <div class="py-3 fill-height">

        <v-select
          :value="selectValue"
          :items="projectOptions.waterside.choices"
          item-title="display_name"
          color="primary"
          item-value="value"
          @update:model-value="onWatersideChanged"
        />
      </div>

      <div style="height:10%" class="py-3">
        <v-btn
          variant="text"
          @click="onBack"
        >
          Back
        </v-btn>
        <v-btn
          variant="flat"
          class="float-end"
          color="primary"
          @click="updateWaterSide"
          :loading="writeLoading"
        >
          Save waterside & Continue
        </v-btn>
      </div>

    </template>
  </v-window-item>
</template>

<script>
  import { mapActions, mapState } from "vuex"

  export default {
    name: "DikeSectionWatersideStep",
    props: {
      step: { type: Number, required: true }
    },
    data: () => ({
      completed: false,
      loading: false,
      writeLoading: false,
      selectedWaterside: null
    }),
    computed: {
      ...mapState("referencePoint", {
        referencePointsLoaded: state => state.loaded
      }),
      ...mapState("project", {
        projectOptions: state => state.options,
        currentProject: state => state.currentProject
      }),
      selectValue: {
        get () {
          const value = this.projectOptions.waterside.choices.find(
            choice => choice.value === this.currentProject.waterside
          )
          return value?.display_name
        },
        set (value) {
          this.selectedWaterside = value
        }
      }

    },
    methods: {
      ...mapActions("project", {
        fetchOptions: "fetchOptions",
        updateProjectParameter: "updateProjectParameter",
        updateProject: "updateProject",
        toggleEdit: "toggleEdit"
      }),
      onBack () {
        this.completed = false
        this.$emit("back")
      },
      onWatersideChanged (waterside) {
        this.selectedWaterside = waterside
      },
      async updateWaterSide () {
        try {
          this.writeLoading = true
          if (this.selectedWaterside !== null) {
            await this.updateProjectParameter({ waterside: this.selectedWaterside })
            await this.updateProject({
              id: this.currentProject.id,
              waterside: this.currentProject.waterside
            })
          }
          this.completed = true
          this.$emit("continue")
        } catch (e) {
          console.log(e)
        } finally {
          this.writeLoading = false
        }
      }
    },
    async mounted () {
      try {
        this.loading = true
        await this.fetchOptions()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
        this.toggleEdit(true)
      }
    }
  }
</script>

<style scoped>


</style>
